import { Badge, Group, Stack, Text } from "@mantine/core";
import { IconStarFilled } from "@tabler/icons-react";
import type { RequiredSkill } from "../../types/api";
import { axioTokens } from "../../theme";
import { ContentCard } from "../ui";

const SKILLS_COPY = {
  label: "Required skills",
  legend: "Star = must-have skill",
  mustHave: "Must-have",
  preferred: "Preferred",
} as const;

const SKILL_BADGE_COLOR = {
  mustHave: "violet",
  preferred: "gray",
} as const;

const SKILL_BADGE_VARIANT = {
  mustHave: "light",
  preferred: "outline",
} as const;

const STAR_ICON_SIZE = "var(--axio-unit-12)";

export function JobRequiredSkills({ skills }: { skills?: RequiredSkill[] | null }) {
  if (!skills?.length) return null;
  return (
    <ContentCard>
      <Stack gap={axioTokens.spacing.md}>
        <Stack gap={axioTokens.spacing.xs}>
          <Text size="xs" c="dimmed" fw="var(--axio-font-weight-semibold)">
            {SKILLS_COPY.label}
          </Text>
          <Text size="xs" c="dimmed">
            {SKILLS_COPY.legend}
          </Text>
        </Stack>
        <Group gap={axioTokens.spacing.sm} wrap="wrap">
          {skills.map((skill, index) => {
            const isMustHave = skill.must_have;
            return (
              <Badge
                key={`${skill.skill_id ?? skill.skill}-${index}`}
                variant={isMustHave ? SKILL_BADGE_VARIANT.mustHave : SKILL_BADGE_VARIANT.preferred}
                color={isMustHave ? SKILL_BADGE_COLOR.mustHave : SKILL_BADGE_COLOR.preferred}
                leftSection={isMustHave ? <IconStarFilled size={STAR_ICON_SIZE} aria-hidden /> : undefined}
                aria-label={`${skill.skill} · ${isMustHave ? SKILLS_COPY.mustHave : SKILLS_COPY.preferred}`}
              >
                {skill.skill}
              </Badge>
            );
          })}
        </Group>
      </Stack>
    </ContentCard>
  );
}
